import { Card, CardContent, CardHeader, CardTitle } from "./card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./tabs";

export function HowToPlay() {
  return (
    <Card className="w-full bg-black/50 border-primary/50 backdrop-blur-sm">
      <CardHeader>
        <CardTitle className="text-2xl font-bold text-primary">
          How to Play
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="basics" className="w-full">
          <TabsList className="w-full bg-transparent border-b border-gray-800">
            <TabsTrigger value="basics" className="flex-1">
              Basics
            </TabsTrigger>
            <TabsTrigger value="scoring" className="flex-1">
              Scoring
            </TabsTrigger>
            <TabsTrigger value="advanced" className="flex-1">
              Advanced Rules
            </TabsTrigger>
          </TabsList>

          <TabsContent value="basics" className="mt-4 space-y-4">
            <div className="bg-gray-900/50 p-4 rounded-lg">
              <h3 className="text-lg font-semibold text-primary mb-2">
                Game Setup
              </h3>
              <ul className="list-disc list-inside space-y-2 text-gray-300">
                <li>Each player receives 5 cards in a 3-2 deal pattern</li>
                <li>Cards range from 6 to King</li>
                <li>Four suits: ♠️ Spades, ♥️ Hearts, ♣️ Clubs, ♦️ Diamonds</li>
              </ul>
            </div>

            <div className="bg-gray-900/50 p-4 rounded-lg">
              <h3 className="text-lg font-semibold text-primary mb-2">
                Basic Rules
              </h3>
              <ul className="list-disc list-inside space-y-2 text-gray-300">
                <li>First player can play any card</li>
                <li>Second player must play same suit if possible</li>
                <li>Higher card of the same suit always wins</li>
                <li>
                  Leader maintains position when opponent doesn't have same suit
                </li>
              </ul>
            </div>
          </TabsContent>

          <TabsContent value="scoring" className="mt-4 space-y-4">
            <div className="bg-gray-900/50 p-4 rounded-lg">
              <h3 className="text-lg font-semibold text-primary mb-2">
                Point System
              </h3>
              <ul className="list-disc list-inside space-y-2 text-gray-300">
                <li>6 cards = 3 points</li>
                <li>7 cards = 2 points (as long as it wasn't used to capture the lead)</li>
                <li>Cards 8-K = 1 point</li>
                <li>First to reach target score wins (default: 10 points)</li>
              </ul>
            </div>

            
          </TabsContent>

          <TabsContent value="advanced" className="mt-4 space-y-4">
            <div className="bg-gray-900/50 p-4 rounded-lg">
              <h3 className="text-lg font-semibold text-primary mb-2">
                Special Rules
              </h3>
              <ul className="list-disc list-inside space-y-2 text-gray-300">
                <li>
                  <span className="text-primary font-semibold">Gbaa Rule:</span>{" "}
                  Playing wrong suit when you could follow suit
                </li>
                <li>
                  <span className="text-primary font-semibold">Under Ten:</span>{" "}
                  All cards in hand below 10
                </li>
                <li>
                  <span className="text-primary font-semibold">Leading:</span>{" "}
                  Capturing opponent's lead with higher card
                </li>
              </ul>
            </div>

            
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}
